module.exports = __webpack_public_path__ + "img/alt.6d639ba7.svg";